export default __webpack_public_path__ + "static/media/iconLocation.0047ff0b.svg";